module.exports = __webpack_public_path__ + "static/img/per10.da86ac6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/per10.jpg
// module id = lb4O
// module chunks = 41